import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProfileUserIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 19.699,
	height: 16.99,
	viewBox: "0 0 19.699 16.99",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Group_5163",
		"data-name": "Group 5163",
		transform: "translate(-2 -4)",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group_5160",
			"data-name": "Group 5160",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Path_8159",
					"data-name": "Path 8159",
					d: "M10.67,13.02c-.22-.01-.44-.02-.67-.02a12.876,12.876,0,0,0-6.61,1.82A2.922,2.922,0,0,0,2,17.35V19a1,1,0,0,0,1,1h8.26A6.963,6.963,0,0,1,10,16,7.072,7.072,0,0,1,10.67,13.02Z",
					fill: "#fff"
				}),
				/* @__PURE__ */ _jsx("circle", {
					id: "Ellipse_5",
					"data-name": "Ellipse 5",
					cx: 4,
					cy: 4,
					r: 4,
					transform: "translate(6 4)",
					fill: "#fff"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_8160",
					"data-name": "Path 8160",
					d: "M20.75,16a4.338,4.338,0,0,0-.06-.63l.84-.73a.5.5,0,0,0,.1-.63l-.59-1.02a.488.488,0,0,0-.59-.22l-1.06.36a3.647,3.647,0,0,0-1.08-.63l-.22-1.09a.5.5,0,0,0-.49-.4H16.42a.5.5,0,0,0-.49.4l-.22,1.09a3.647,3.647,0,0,0-1.08.63l-1.06-.36a.5.5,0,0,0-.59.22l-.59,1.02a.5.5,0,0,0,.1.63l.84.73a4.338,4.338,0,0,0-.06.63,4.338,4.338,0,0,0,.06.63l-.84.73a.5.5,0,0,0-.1.63l.59,1.02a.488.488,0,0,0,.59.22l1.06-.36a3.647,3.647,0,0,0,1.08.63l.22,1.09a.5.5,0,0,0,.49.4H17.6a.5.5,0,0,0,.49-.4l.22-1.09a3.647,3.647,0,0,0,1.08-.63l1.06.36a.5.5,0,0,0,.59-.22l.59-1.02a.5.5,0,0,0-.1-.63l-.84-.73A4.338,4.338,0,0,0,20.75,16ZM17,18a2,2,0,1,1,2-2A2.006,2.006,0,0,1,17,18Z",
					fill: "#fff"
				})
			]
		})
	})
});
export { SvgProfileUserIcon as ReactComponent };
